import { IKogIcon } from '@/main/@types/interfaceIcons'
import React from 'react'

export function TransferredIcon({
  height = '50px',
  width = '50px',
  color = 'currentColor'
}: IKogIcon) {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 439.000000 382.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,382.000000) scale(0.100000,-0.100000)"
        fill={color}
        stroke="none"
      >
        <path d="M3111 3688 c-51 -14 -97 -54 -123 -106 -22 -46 -23 -55 -26 -389 l-3
          -343 -1413 0 -1413 0 -27 -21 c-33 -26 -35 -71 -4 -93 20 -14 173 -16 1440
          -16 l1417 0 3 -347 3 -348 25 -45 c38 -67 96 -103 173 -108 46 -2 71 1 97 15
          36 19 918 718 956 758 37 38 54 82 54 140 0 67 -14 96 -72 151 -69 66 -899
          724 -940 745 -40 20 -92 23 -147 7z m555 -485 c253 -203 464 -379 471 -392 9
          -19 9 -31 0 -53 -13 -30 -907 -751 -944 -760 -38 -10 -81 17 -93 59 -8 27 -10
          249 -8 751 l3 714 28 24 c56 48 49 53 543 -343z"
        />
        <path d="M1090 1842 c-19 -10 -246 -187 -505 -393 -512 -409 -505 -403 -505
          -505 0 -64 14 -96 67 -145 74 -71 929 -745 961 -758 39 -16 116 -9 168 15 47
          23 90 82 103 145 7 30 11 178 11 364 l0 315 1414 0 1413 0 27 21 c33 26 35 71
          4 93 -20 14 -173 16 -1440 16 l-1418 0 0 318 c-1 174 -5 337 -9 361 -26 131
          -178 212 -291 153z m132 -126 c10 -7 22 -25 28 -40 14 -38 14 -1422 0 -1463
          -12 -32 -45 -53 -85 -53 -16 0 -159 108 -452 341 -235 188 -445 358 -465 377
          -43 41 -50 86 -21 120 17 19 841 679 893 715 29 20 78 22 102 3z"
        />
      </g>
    </svg>

  )
}